import React from 'react';
import { CardView } from 'design-system/CardView';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { fragmentRenderers } from './fragments';
import { resolveScenario } from './resolveScenario';
/**
 * Presentational grey-box description shown in the subscription preview modals.
 * Dumb by design: it resolves the model to an ordered fragment list and renders
 * each fragment, separated by spaces. No store access, no data fetching — the
 * modals build the normalized model.
 */
const CalculationDescription = ({ model }) => {
    const styles = useStyles(styleSet);
    const fragments = resolveScenario(model);
    return (<CardView withPadding noMarginTop style={styles.card} testID="calculationDescription">
      <Text TextThin-14 Secondary>
        {fragments.map((fragment, index) => (<React.Fragment key={fragment}>
            {index > 0 ? ' ' : null}
            {fragmentRenderers[fragment](model)}
          </React.Fragment>))}
      </Text>
    </CardView>);
};
const styleSet = createStyleSheets((colors) => ({
    card: {
        backgroundColor: colors.background.dark,
        marginBottom: rem(8),
    },
}));
export default React.memo(CalculationDescription);
